module.exports = __webpack_public_path__ + "static/img/200283.2ce2e654.png";